module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        country: {
            type: 'string'
        },
        key: {
            type: 'string'
        },
        account: {
            type: 'string'
        },
        sepaElectronic: {
            type: ['boolean', 'null']
        }
    }
};
